import React from 'react';
import imgGbl from 'src/assets/images/gbl-logo.svg';
import imgUrbanone from 'src/assets/images/urban-one-builders.svg';
import imgPortico from 'src/assets/images/portico-design-group.svg';
import imgRennie from 'src/assets/images/rennie_logo_v3.svg';

const data = [
  {
    title: 'Architects',
    data: (
      <p>
        <img src={imgGbl} alt="GBL Architects" />
        GBL Architects Inc. is a progressive Vancouver-based firm of 60
        architects, project managers, and technicians with 25 years of
        experience providing a full range of architectural services to the
        private and public sector. The firm has built its reputation on
        high-quality design, tight project management, technical proficiency,
        financial and social responsibility, and modern artistry. The company
        prides itself in finding innovative solutions constructive to both the
        users and the public. GBL is a member of the Canada Green Building
        Council and The Cascadia Region Green Building Council and regularly
        practices green design through the LEED Canada Program.
      </p>
    ),
  },
  {
    title: 'Construction',
    data: (
      <p>
        <img src={imgUrbanone} alt="Urban One Builders" />
        Urban One Builders is a full-service construction company focused on
        largescale, mixed-use, and multi- family anchored projects. The Urban
        One team has worked on numerous landmark building projects in British
        Columbia and Alberta over the past 20 years, with many multi-tower
        projects being in excess of 500,000 square feet. They are currently
        constructing a number of iconic projects around the city, including the
        landmark Trump Vancouver, Tate Downtown, UBC Tall Wood Residences, and a
        number of other high-end, multifamily projects.
      </p>
    ),
  },
  {
    title: 'Interior Design',
    data: (
      <p>
        <img src={imgPortico} alt="Portico Design Group" />
        Portico Design Group is a Vancouver-based full-service interior design
        firm providing design services to private residential clients, resort
        operators, and residential and commercial real estate developers.
        Portico’s philosophy of “Bringing space to life” is achieved by creating
        dramatic interiors with a sense of discovery. Every detail of a project
        is researched, considered for relevance, and then drawn to exacting
        specifications. This attention to detail is paramount to arriving at the
        best possible solution.
      </p>
    ),
  },
  {
    title: 'Developer Services',
    data: (
      <p>
        <img src={imgRennie} alt="Marketing by Rennie" />
        For more than forty years, rennie has partnered with developers
        throughout Western Canada and Washington State to help acquire, plan,
        design, approve, market and sell some of the region’s largest and most
        successful communities. Integrating data intelligence, strategic
        perspective, and industry experience, its head office team of 70 and
        more than 150 Realtors in the field work seamlessly to deliver products
        and sales to build their clients’ brands and ensure continued success.
      </p>
    ),
  },
];

export default data;



// WEBPACK FOOTER //
// ./src/data/team.js